const Separator = () => <span style={style}>/</span>

const style = {
  margin: '0 1rem',
  userSelect: 'none',
} satisfies React.CSSProperties

export default Separator
